// @flow

// Libs
import { createSelector } from 'reselect'

// Selectors
import selectedJob$ from './selectedJob'

// Constants
import { PROP_PREVIOUS_POINTS } from 'fc-model-sampling-jobs'

// Types
import type { Job } from 'fc-model-sampling-jobs/types'
import type { Point } from 'fc-model-sampling-points/types'

export default createSelector([selectedJob$], (selectedJob: Job): ?Array<Point> =>
  selectedJob ? selectedJob[PROP_PREVIOUS_POINTS] : null
)
